export const CURRENCY_REGEX = /[^0-9\.\-]/gi;
export const NUMBER_REGEX = /[^0-9\-]/gi;

export function parseValue(rawValue, formatType) {
  const fallbackValue = (formatType == 'currency' ? 0.00 : 0);
  const regex = (formatType == 'currency' ? CURRENCY_REGEX : NUMBER_REGEX);
  const parser = (formatType == 'currency' ? parseFloat : parseInt);
  const cleanedValue = rawValue.toString().replaceAll(regex, "").trim();
  const value = parser(cleanedValue);

  return isNaN(value) ? fallbackValue : value;
}
